import { WhatsappWidget } from '@/landing/components/whatsapp-widget.component';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    template: `
    <router-outlet></router-outlet>
    `
})
export class AppComponent {}
